module.exports = __webpack_public_path__ + "static/media/C023.f3dee42c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/carousel/C023.jpg
// module id = 306
// module chunks = 0